import { render, staticRenderFns } from "./VisitRegistryAdd.vue?vue&type=template&id=0d8c2117&scoped=true"
import script from "./VisitRegistryAdd.vue?vue&type=script&lang=js"
export * from "./VisitRegistryAdd.vue?vue&type=script&lang=js"
import style0 from "./VisitRegistryAdd.vue?vue&type=style&index=0&id=0d8c2117&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d8c2117",
  null
  
)

export default component.exports